import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DemographicContentService } from 'src/app/services/demographic-content.service';

@Component({
  standalone: true,
  selector: 'app-demographic-modal',
  templateUrl: './demographic-modal.component.html',
  styleUrls: ['./demographic-modal.component.scss']
})

export class DemographicModalComponent implements OnDestroy {

  @Input()
  set hospitalName(name: string | null) {
    this._hospName = name ?? '';
    this.onHospNameChange();
  }
  get hospitalName(): string {
    return this._hospName ?? '';
  }

  data: any;
  private _hospName: string;
  private $subscriptions: Subscription = new Subscription();

  constructor(private demographicContentService: DemographicContentService) { }

  private onHospNameChange() {
    const contentSub$ = this.demographicContentService.getDemographicContent(this.hospitalName).subscribe(res => {
      if (res && res[0]) {
        this.data = res[0];
      } else {
        this.data = {};
      }
    });

    this.$subscriptions.add(contentSub$);
  }


  ngOnDestroy() {
    if (this.$subscriptions) {
      this.$subscriptions.unsubscribe();
    }
  }

}
